import * as React from 'react'

import { ImageSkuBlock } from "@components"


export default function imageSkuColumn() {
    return {
        name: 'skuID', label: ' ',
        options: {
            headerAlign: 'left',
            customBodyRowRenderLite: (value, { skuName }) => <ImageSkuBlock
                skuID={value}
                skuName={skuName}
                contentProps={{
                    sx: { margin: '0' }
                }}
            />
        }
    }
}